import * as React from "react";
import { api, user } from "src/services/api";
import { route, routeApi } from "src/services/browser";
import { notify } from "src/services/notify";

import { Formatters, Loading, Modal } from "src/components/ui";

interface Props {
    id: any;
    onClose: Function;
    other: "ADSP" | "ADWORDS";
}
interface State {
  item?: any;
  confirm: boolean;
}
export class AbbonamentoEdit extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
          confirm: false
        };
    }

    async componentWillMount() {
      const item = await api({
          url: routeApi('abbonamento.show', { abbonamento: this.props.id }),
          method: 'get'
      });
      this.setState({
        item
      });
    }

    async unSubscribe() {
      const { item, confirm } = this.state;

      if (!confirm) {
        this.setState({
          confirm: true
        });
      } else {
        await api({
            url: routeApi('abbonamento.unsubscribe', { abbonamento: item.id }),
            method: 'get'
        });
        notify( { text: 'Abbonamento cancellato correttamente.', type: 'success' } );
        this.cancel();
      }

    }
    
    cancel() {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }
  
    render() {
        const { id, other } = this.props;
        const { item, confirm } = this.state;
        if (!item) return null;
        
        return (
            <Modal
              open={true}
              backdrop={true}
              className="ecommerce_AbbonamentoEdit"
              onClose={() => this.cancel()}
            >
              <header>
                <h2>Abbonamento attivo</h2>
                {item.recipient_subtype === "scuola" &&
                <>
                  <h3>{item.recipient.nome}</h3>
                  <p>{item.recipient.indirizzo_completo}</p>
                </>
                }
              </header>
              <div className="content">
                <h3>Abbonamento attivo</h3>
                <article>
                  <span>{item.tipologia.nome}</span>
                  {!item.cancellato &&
                    <span>
                      <span className="status available"></span>
                      Data attivazione: <em>{Formatters.Date({date: item.data_inizio})}</em>
                    </span>
                  }
                  {item.cancellato &&
                    <span>
                      <span className="status wait"></span>
                      Attivo fino a: <em>{Formatters.Date({date: item.data_sospensione})}</em>
                    </span>
                  }
                  <span>
                    {!item.cancellato &&
                    <button className="cancel xs" onClick={() => this.unSubscribe()}><span>Disattiva</span></button>
                    }
                  </span>
                </article>
              </div>
              <div className="confirm">
              {confirm &&
                <>
                <span>Confermi disattivazione di {item.tipologia.nome}?</span>
                <span><button className="report xs" onClick={() => this.unSubscribe()}><span>Conferma</span></button></span>
                </>
              }
              </div>
              {other === "ADSP" &&
              <footer className="adsp">
                <div>
                  <p>In <em>homepage</em> aumenti la tua visibilità del 90%</p>
                  <p><em>Acquista Visor Vetrina</em> per questa sede.</p>
                  <nav>
                    <div><a href={route("profile.ecommerce.ads.adsp.index", {scuola: item.id})} className="btn action btn-block md"><span>Voglio acquistare</span></a></div>
                    <div><a onClick={() => this.props.onClose()}>No grazie, preferisco pensarci</a></div>
                  </nav>
                </div>
              </footer>
              }
              {other === "ADWORDS" &&
              <footer className="adwords">
                <div>
                  <p><em>In testa alle ricerche</em> aumenti la tua visibilità del 90%</p>
                  <p><em>Acquista Visor AD Words</em> per questa sede.</p>
                  <nav>
                    <div><a href={route("profile.ecommerce.ads.adsp.index", {scuola: item.id})} className="btn action btn-block md"><span>Voglio acquistare</span></a></div>
                    <div><a onClick={() => this.props.onClose()}>No grazie, preferisco pensarci</a></div>
                  </nav>
                </div>
              </footer>
              }
            </Modal>
        );
    }
}

interface StateToggler {
    open: "modal" | null;
    other?: any;
}
export default class AbbonamentoEditToggler extends React.Component<any, StateToggler> {
    constructor(props) {
        super(props);
        this.state = {
            open: null
        };
    }
    
    execute() {
      this.setState({
        open: "modal",
        other: Math.random() >= 0.5 ? "ADSP" : "ADWORDS"
      });
    }
    
    render() {
        const { open = null } = this.state;
        const props = {
            ...this.props,
            other: this.state.other,
            onClose: () => this.setState({open: null})
        } as any;
        return (
        <>
            {open === "modal" &&
            <AbbonamentoEdit {...props} />
            }
            <span onClick={() => this.execute() }>
                {this.props.children}
            </span>
        </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/AbbonamentoEdit.tsx